
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetDangerousNocoghdgIec as ObiAisTargetDangerousNocoghdgIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-dangerous-nocoghdg-iec.js';
 
 
 

 
 export const ObiAisTargetDangerousNocoghdgIec = createComponent({
   react: React,
   tagName: 'obi-ais-target-dangerous-nocoghdg-iec',
   elementClass: ObiAisTargetDangerousNocoghdgIecElement,
   events: {
     
   }
  });
 
 